import 'css-chunksrc/client/scenes/task/allocations/allocation/completion/completionInput/styles.scss';export default {
  "completionInput": "_completionInput_pqq0y_1",
  "edition": "_edition_pqq0y_7",
  "input": "_input_pqq0y_11",
  "text": "_text_pqq0y_31"
};